/* @ngInject */
const axletreeFields = (
  icons,
  types,
  axletreeLabels
) => {
  const self = {}

  self.position = {
    ref: 'position',
    label: axletreeLabels.fields.position.text,
    icon: icons.axletree.position,
    type: types.select,
    options: 'position for position',
    order: 'position.toString()',
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: false, },
      select: true,
    },
  }

  self.decision = {
    ref: 'decision',
    label: axletreeLabels.fields.decision.text,
    icon: icons.axletree.decision,
    type: types.select,
    options: 'decision for decision',
    order: 'decision.toString()',
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: false, },
      select: true,
    },
  }

  self.number = {
    ref: 'number',
    label: axletreeLabels.fields.number.text,
    icon: icons.axletree.number,
    type: types.text(),
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: false, },
      select: true,
    },
  }

  self.weight = {
    ref: 'weight',
    label: axletreeLabels.fields.weight.text,
    icon: icons.axletree.weight,
    type: types.decimal,
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: true, },
      select: true,
    },
  }

  self.type = {
    ref: 'type',
    label: axletreeLabels.fields.type.text,
    icon: icons.axletree.type,
    type: types.text(),
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: false, },
      select: true,
    },
  }

  self.diameter = {
    ref: 'diameter',
    label: axletreeLabels.fields.diameter.text,
    icon: icons.axletree.diameter,
    type: types.decimal,
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: false, },
      select: true,
    },
  }

  self.material = {
    ref: 'material',
    label: axletreeLabels.fields.material.text,
    icon: icons.axletree.material,
    type: types.text(),
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: false, },
      select: true,
    },
  }

  self.wagonId = {
    ref: 'wagonId',
    label: axletreeLabels.fields.wagonId.text,
    icon: icons.axletree.wagonId,
    type: types.wagonId,
    output: {
      sortable: true,
      table: { prefill: false, },
      details: false,
      excel: { prefill: false, },
      select: true,
    },
  }

  self.expeditionDate = {
    ref: 'expeditionDate',
    label: axletreeLabels.fields.expeditionDate.text,
    icon: icons.axletree.expeditionDate,
    type: types.date,
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: true, },
      select: true,
    },
  }

  self.expeditionPlace = {
    ref: 'expeditionPlace',
    label: axletreeLabels.fields.expeditionPlace.text,
    icon: icons.axletree.expeditionPlace,
    type: types.text(),
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: true, },
      select: true,
    },
  }

  return self
}
export default axletreeFields



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/axletree/resources/fields.resource.js